import { Component, OnDestroy, OnInit, isDevMode } from '@angular/core';
import { MessageService } from 'primeng/api';
import { Router } from '@angular/router';
import { AuthentificationService } from 'src/app/services/auth/authentification.service';

@Component({
  selector: 'app-timeout',
  templateUrl: './timeout.component.html',
  styleUrls: ['./timeout.component.scss']
})
export class TimeoutComponent implements OnInit, OnDestroy {

  constructor(private router: Router, private messagesService: MessageService,
    private authentificationService: AuthentificationService) { }

  DEFAULT_IDLE_TIMEOUT_DELAY_SEC = 900;
  AFTER_EXTENSION_IDLE_TIMEOUT_DELAY_SEC = 900;
  EXTEND_SESSION_WINDOW_OPEN_DELAY_SEC = 60;

  timeoutWarningPhase = false;
  idleTimeoutDelaySec = this.DEFAULT_IDLE_TIMEOUT_DELAY_SEC;
  idleTimeoutDelayRemainingSec = this.idleTimeoutDelaySec;
  extendSessionWindowRmainingSec;

  idleTimer;
  extendSessionTimer;
  debugMode = false;

  buffer = '';

  ngOnInit(): void {
    this.setIdleTimer();
    this.setClickEventListener();
    if (isDevMode()) {
      this.initDebugger();
    }

  }

  ngOnDestroy(): void {
    this.clearTimers();
  }


  setIdleTimer() {
    this.idleTimeoutDelayRemainingSec = this.idleTimeoutDelaySec;
    clearInterval(this.idleTimer);
    this.idleTimer = null;
    this.idleTimer = setInterval(() => {
      this.idleTimeoutDelayRemainingSec--;
      if (this.idleTimeoutDelayRemainingSec == 0) {
        this.startTimeoutWarningPhase();
      }
    }, 1000);
  }

  setClickEventListener() {
    document.addEventListener('click', () => {
      if (!this.timeoutWarningPhase) {
        this.idleTimeoutDelayRemainingSec = this.idleTimeoutDelaySec;
      }
    });
    document.addEventListener('keydown', () => {
      if (!this.timeoutWarningPhase) {
        this.idleTimeoutDelayRemainingSec = this.idleTimeoutDelaySec;
      }
    });
  }

  startTimeoutWarningPhase() {
    this.clearTimers();
    this.timeoutWarningPhase = true;
    this.extendSessionWindowRmainingSec = this.EXTEND_SESSION_WINDOW_OPEN_DELAY_SEC;
    this.messagesService.add({ key: 'sessionWarning', severity: 'warn', sticky: true, closable: false })
    this.extendSessionTimer = setInterval(() => {
      this.extendSessionWindowRmainingSec--;
      if (this.extendSessionWindowRmainingSec == 0) {
        this.endSession();
      }
    }, 1000);
  }


  extendSession() {
    this.idleTimeoutDelaySec = this.AFTER_EXTENSION_IDLE_TIMEOUT_DELAY_SEC;
    this.extendSessionWindowRmainingSec = this.EXTEND_SESSION_WINDOW_OPEN_DELAY_SEC;
    clearInterval(this.extendSessionTimer);
    clearInterval(this.idleTimer);
    this.timeoutWarningPhase = false;
    this.messagesService.clear();
    this.setIdleTimer();
  }

  closeSessionTimeoutWarning() {
    this.messagesService.clear();
    this.router.navigate(['/auth/login']);
  }


  endSession() {
    this.authentificationService.httpLogout().subscribe();
    this.authentificationService.clearAccessStorage();
    this.messagesService.clear();
    this.messagesService.add({ key: 'sessionError', severity: 'error', sticky: true, closable: false })
    clearInterval(this.extendSessionTimer);
    clearInterval(this.idleTimer);
  }

  clearTimers() {
    clearInterval(this.extendSessionTimer);
    clearInterval(this.idleTimer);
    this.extendSessionTimer = null;
    this.idleTimer = null;
  }

  initDebugger() {
    document.addEventListener("keyup", (event) => {
      this.buffer = this.buffer + event.key;
      if (this.buffer.indexOf('debugon') != -1) {
        this.debugMode = true;
        this.buffer = '';
      }
      if (this.buffer.indexOf('debugoff') != -1) {
        this.debugMode = false;
        this.buffer = '';
      }
    });
  }

  stop() {
    this.clearTimers();
  }

}
